import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceNoteForm from '../containers/ResourceNoteFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceNoteAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceNoteAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_note_route_add')} />
          <ResourceNoteForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceNoteAddScreen;

Logger.log('silly', `ResourceNoteAddScreen loaded.`);
